import { extendTheme } from '@chakra-ui/react'

const fontStack = "'Atkinson Hyperlegible', system-ui, -apple-system, sans-serif"

const lumeneTheme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },

  colors: {
    lumene: {
      night:  '#1A1D24',
      off:    '#F8F4EC',
      copper: '#B08D5B',
      bronze: '#6B4423',
      red:    '#8B2616',
      white:  '#FFFFFF',
    },
    brand: {
      50:  '#F8F4EC',
      500: '#B08D5B',
      700: '#6B4423',
      900: '#1A1D24',
    },
  },

  fonts: {
    heading: fontStack,
    body:    fontStack,
  },

  fontWeights: {
    normal: 400,
    bold:   700,
  },

  radii: {
    sm:   '4px',
    md:   '8px',
    lg:   '12px',
    xl:   '16px',
    '2xl':'24px',
    '3xl':'36px',
    full: '9999px',
  },

  styles: {
    global: {
      // NO overflow:hidden on body — Chakra Modal manages scroll lock itself.
      'html, body': {
        bg: '#1A1D24',
        color: '#F8F4EC',
        fontFamily: fontStack,
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
      },
      '#root': {
        minHeight: '100dvh',
      },
      // Global focus-visible ring for elements that bypass Chakra (e.g. inline buttons)
      'button:focus-visible, a:focus-visible, [role="button"]:focus-visible': {
        outline: '2px solid #B08D5B',
        outlineOffset: '3px',
      },
    },
  },

  components: {
    Button: {
      baseStyle: {
        fontWeight: 'bold',
        _focusVisible: {
          outline: '2px solid #B08D5B',
          outlineOffset: '3px',
          boxShadow: 'none',
        },
      },
      variants: {
        // AudioBar play/pause button
        lumeneAudio: {
          bg: '#B08D5B',
          color: '#1A1D24',
          borderRadius: 'full',
          _hover:   { bg: '#9A7A4A' },
          _active:  { bg: '#8A6A3A' },
          _focusVisible: {
            outline: '2px solid #B08D5B',
            outlineOffset: '3px',
            boxShadow: 'none',
          },
        },
        // AudioBar replay button — transparent ghost
        lumeneAudioGhost: {
          bg: 'transparent',
          color: '#F8F4EC',
          borderRadius: 'full',
          _hover:  { bg: 'rgba(248,244,236,0.10)' },
          _active: { bg: 'rgba(248,244,236,0.18)' },
          _focusVisible: {
            outline: '2px solid #B08D5B',
            outlineOffset: '3px',
            boxShadow: 'none',
          },
        },
        // Primary CTA on light surfaces (sheets)
        lumenePrimary: {
          bg: '#1A1D24',
          color: '#F8F4EC',
          borderRadius: 'md',
          _hover:  { bg: '#2A2D34' },
          _active: { bg: '#0A0D14' },
          _focusVisible: {
            outline: '2px solid #B08D5B',
            outlineOffset: '3px',
            boxShadow: 'none',
          },
        },
      },
    },

    IconButton: {
      baseStyle: {
        _focusVisible: {
          outline: '2px solid #B08D5B',
          outlineOffset: '3px',
          boxShadow: 'none',
        },
      },
    },

    Modal: {
      baseStyle: {
        overlay: {
          bg: 'rgba(26,29,36,0.75)',
        },
      },
    },
  },
})

export default lumeneTheme
